/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Inbound_OnlyInputs */

const cs_messages_inbound_only = /** @type {(inputs: Messages_Inbound_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpovězte odtud — pokud portál neumí odeslat odpověď, pošleme e-mail tazateli.`)
};

const en_messages_inbound_only = /** @type {(inputs: Messages_Inbound_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply from here when you can — portal APIs that cannot send will e-mail the inquirer instead.`)
};

/**
* | output |
* | --- |
* | "Reply from here when you can — portal APIs that cannot send will e-mail the inquirer instead." |
*
* @param {Messages_Inbound_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_inbound_only = /** @type {((inputs?: Messages_Inbound_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Inbound_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_inbound_only(inputs)
	return cs_messages_inbound_only(inputs)
});